





























import Vue from 'vue';
import { hideScroll, setScroll } from '@/utils';
import { Toast } from '@zyf2e/capui-mobile';

Vue.use(Toast);
export default Vue.extend({
  name: 'SearchBar',
  data() {
    return {
      value: 'hihi'
    };
  },
  props: {
    searchValue: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: NaN
    },
    placeholderText: {
      type: String,
      default: '请输入搜索关键词'
    },
    showAction: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    autoFocus: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    searchValue: {
      handler(newval) {
        this.value = newval;
      },
      immediate: true
    }
  },
  mounted() {
    if (this.autoFocus) {
      (document.querySelector('input') as HTMLElement).focus();
    }
  },
  methods: {
    onCancel() {
      setScroll();
      this.$emit('onCancel', this.value);
    },
    onSearch() {
      if (!this.value) {
        Toast('搜索内容不能为空');
        return;
      }
      setScroll();
      this.$emit('onSearch', this.value);
    },
    onFocus() {
      hideScroll();
      this.$emit('onFocus');
    }
  }
});
